import { Link } from "react-router-dom";

export const Footer = ({ config }) => (
  <footer className="border-t border-white/5 mt-16">
    <div className="max-w-7xl mx-auto px-6 py-14">
      <div className="flex flex-col md:flex-row justify-between gap-8 mb-10">
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="HoodBank" className="w-10 h-10 rounded-lg object-contain" />
          <p className="font-heading font-bold text-lg">Hood<span className="text-[#00C805]">Bank</span></p>
        </div>
        <div className="flex gap-8 text-sm text-neutral-400 font-mono items-center">
          <a href="https://x.com/hoodbank_cc" target="_blank" rel="noreferrer" className="hover:text-white transition-colors duration-200">X</a>
          <a href={config?.explorer_url} target="_blank" rel="noreferrer" className="hover:text-white transition-colors duration-200">Explorer</a>
          <Link to="/account" className="hover:text-white transition-colors duration-200">Account</Link>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors duration-200">Admin</Link>
        </div>
      </div>
      <p data-testid="footer-disclaimer" className="text-xs text-neutral-600 leading-relaxed max-w-4xl">
        HoodBank ($BANK) is a community token, not a bank, deposit product, or financial service,
        and is not affiliated with or endorsed by Robinhood Markets. Rewards depend entirely on
        trading-fee revenue and are not interest, yield promises, or guaranteed. This site never
        asks for your seed phrase, private keys, or passwords. Nothing here is financial advice.
      </p>
    </div>
  </footer>
);
